// extracted by mini-css-extract-plugin
export default {"wrapper":"webcams-preview-module--wrapper--9636a"};